(function() { window.GUID_74ee45ac_2c90_425d_a930_247ab2c83f8e = { getGuid: function() { return "74ee45ac-2c90-425d-a930-247ab2c83f8e"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ChartJS {
            static get instance() {
                if (!ChartJS._instance) {
                    ChartJS._instance = new ChartJS();
                }
                return ChartJS._instance;
            }
            constructor() {
                this._chartsData = {};
            }
        }
        Controls.ChartJS = ChartJS;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=chart.js.map
